import uuidv4 from "uuid/v4";

// Returns a random UUID (RFC4122 v4 UUID).
// No guarentee for no collisions. 
// But the chance of getting a 50% chance of ONE collision requires us to generate a billion each second for 100 years.
// We're good for now.
export default function GenerateUUID() {
    return uuidv4();
}